/** Платформенные границы цены за тонну, ₽ без НДС: их проверяют формы продажи, прайс-листа и массового изменения цен. */
export const PRICE_MIN = 1000;
export const PRICE_MAX = 999_999;
